export class NPS {
    npsId: string
    createdAt?: Date
    updatedAt?: Date
    companyId: string
    status: number
    rating?: number
    googleOn: boolean
    googleName?: string
    googleRankInitial?: number
    googleRankCurrent?: number
    googleReviewsInitial?: number
    googleReviewsCurrent?: number
    googleDateInitial?: Date
    googleDateCurrent?: Date
    googleURL?: string
    googlePlaceId?: string
}
